// extracted by mini-css-extract-plugin
export default {"WeatherWidget":"WeatherWidget_WeatherWidget__3XlYt","WeatherDetails":"WeatherWidget_WeatherDetails__1y3CA"};